export const REGISTER_URL = '/register'
export const LOGIN_URL = '/login'
export const PROFILE_URL = '/profile'
export const EXCLUSIVE_CALL_URL = '/calls/exclusive'
export const MY_CALLS_URL = '/calls/mycalls'
export const COMPANY_CALLS_URL = '/calls/company'
export const COMPANY_SETTINGS_URL = '/company-settings'
export const COMPANY_SERVICE_PRICES_URL = '/company-service-prices'
export const EMPLOYEE_SETTINGS_URL = '/employee-settings'
export const PROFILE_SETTINGS_URL = '/profile-settings'
export const EMPLOYEE_REQUESTS_URL = '/employee-requests'
export const DETAILED_CALL_URL = '/calls/'
